import { render, staticRenderFns } from "./WedSupplementaryAccount.vue?vue&type=template&id=170e7b92&scoped=true"
import script from "./WedSupplementaryAccount.vue?vue&type=script&lang=js"
export * from "./WedSupplementaryAccount.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "170e7b92",
  null
  
)

export default component.exports